<template>
  <div class="menu-overlay" @click.self="closeMenu">
    <div
      class="menu"
      @mouseenter="keepMenuOpen"
      @mouseleave="startClose"
    >
      <ul class="menu-items">
        <li>
          <router-link to="/profile">
            <i class="fas fa-user"></i>
            Perfil
          </router-link>
        </li>
        <li>
          <div
            @click="toggleSubMenu"
            class="menu-link"
            :class="{ active: showSubMenu }"
          >
            <i class="fas fa-wallet left-icon"></i>
            Carteira
            <i
              class="fas chevron"
              :class="{
                'fa-chevron-up rotated': showSubMenu,
                'fa-chevron-down': !showSubMenu
              }"
            ></i>
          </div>
          <ul v-if="showSubMenu" class="submenu">
            <li>
              <router-link to="/dashboard">
                Dashboard
              </router-link>
            </li>
            <li>
              <router-link to="/trades">
                Trades
              </router-link>
            </li>
          </ul>
        </li>
        <li>
          <router-link to="/analysis">
            <i class="fas fa-chart-line"></i>
            Análises
          </router-link>
        </li>
        <li>
          <router-link to="/courses">
            <i class="fas fa-play-circle"></i>
            Aulas
          </router-link>
        </li>
        <li>
          <router-link to="/notifications">
            <i class="fas fa-bell"></i>
            Notificações
          </router-link>
        </li>
        <li>
          <router-link to="/support">
            <i class="fas fa-headset"></i>
            Suporte
          </router-link>
        </li>
        <li class="logout-button">
          <a @click="logout">
            <i class="fas fa-sign-out-alt"></i>
            Logout
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  data() {
    return {
      showSubMenu: false,
    };
  },
  methods: {
    closeMenu() {
      this.$emit('close-menu');
    },
    startClose() {
      this.$emit('start-close');
    },
    keepMenuOpen() {
      this.$emit('keep-open');
    },
    toggleSubMenu() {
      this.showSubMenu = !this.showSubMenu;
    },
    logout() {
      localStorage.removeItem('user-token');
      localStorage.removeItem('token');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('zima_show_welcome_once');
      localStorage.removeItem('notifications-data');
      this.$store.dispatch('clearUser');
      this.$store.dispatch('clearBybitConnection');
      window.dispatchEvent(new CustomEvent('notifications-updated', { detail: [] }));
      this.$router.replace({ name: 'Login' });
    },
  },
};
</script>

<style scoped>
:root {
  --transition-speed: 0.3s;
}

.menu-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding-top: 58px;
  padding-right: max(18px, calc((100vw - 1200px) / 2 + 30px));
  pointer-events: auto;
}

.menu {
  position: relative;
  right: 0;
  top: 0;
  transform: none;
  width: 210px;
  background-color: #1e2329;
  padding: 14px 12px 16px;
  border-radius: 16px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.menu-items {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-items li {
  margin: 12px 0;
}

.menu-items a,
.menu-link {
  color: #ffffff;
  text-decoration: none;
  font-size: 1.05rem;
  padding: 10px 14px;
  border-radius: 50px;
  font-weight: 700;
  background-color: transparent;
  border: 2px solid #4e73df;
  transition: background-color var(--transition-speed), color var(--transition-speed), transform var(--transition-speed);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  width: 100%;
  text-align: left;
  position: relative;
  padding-right: 36px;
  padding-left: 16px;
}

.menu-link.active {
  background-color: #4e73df;
}

.menu-link .chevron {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  transition: transform var(--transition-speed);
}

.menu-items a i,
.menu-link .left-icon,
.submenu a i {
  font-size: 1rem;
  width: 18px;
  text-align: center;
  flex-shrink: 0;
}

.menu-link .left-icon {
  margin-right: 2px;
}

.rotated {
  transform: translateY(-50%) rotate(180deg);
}

.menu-items a:hover {
  background-color: #4e73df;
  color: #ffffff;
  cursor: pointer;
}

.menu-link:hover {
  background-color: #4e73df;
  color: #ffffff;
  cursor: pointer;
}

.submenu {
  list-style: none;
  padding-left: 0;
  margin: 10px 0 0;
}

.submenu li {
  margin: 6px 0;
}

.submenu a {
  color: #ffffff;
  font-size: 0.95rem;
  padding: 7px 10px;
  border-radius: 8px;
  border: none;
  overflow: hidden;
  text-decoration: none;
  transition: color var(--transition-speed), background-color var(--transition-speed), width var(--transition-speed);
  margin: 0 auto;
  width: 100%;
  text-align: left;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}

.submenu a::after {
  content: '';
  display: block;
  width: 0;
  height: 4px;
  background: #7394f0;
  transition: width var(--transition-speed);
  position: absolute;
  bottom: -1px;
  left: 0;
}

.submenu a:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: #7394f0;
}

.submenu a:hover::after {
  width: 100%;
}

.logout-button a {
  background: linear-gradient(135deg, #5f27cd 0%, #3498db 100%);
  padding: 10px 14px;
  border-radius: 50px;
  font-weight: 700;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
  transition: background-color var(--transition-speed), transform var(--transition-speed);
  border: none;
  padding-left: 16px;
}

.logout-button a:hover {
  background: linear-gradient(135deg, #4e73df 0%, #9b59b6 100%);
  transform: translateY(-3px);
  text-decoration: none;
}
</style>
